/**
 * Форма чисел оплаты мест (В7) на границе доверия: сумма и места приходят с
 * сервера и уходят на экран и в Stripe. Общие для разбора отказов
 * (`event-seat-refusal-codes.ts`) и ответов расчёта и заказа мест
 * (`api/event-capacity.api.ts`), чтобы обе стороны понимали «сумму» и «места»
 * одинаково. «Места» отсюда же читает и вместимость на экранах записи
 * (`utils/events/bookable-capacity.ts`, №245).
 */

/** Денежная сумма: конечное число, не меньше нуля. */
export const isAmount = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value) && value >= 0;

/** Число мест: целое, не меньше нуля. */
export const isSeatCount = (value: unknown): value is number =>
  typeof value === "number" && Number.isInteger(value) && value >= 0;
